// define global window in case this is used in nodejs
if (typeof global !== 'undefined' && typeof window === 'undefined') {
  global.window = {
    location: {
      host: '',
      origin: '',
      pathname: '',
      href: '',
    },
    document: {
      querySelector: () => ({
        lang: '',
      }),
    },
    requestAnimationFrame: (callback) => {
      setTimeout(callback, 0);
    },
  };
}

const HOSTS = [
  {
    env: 'PROD',
    cdn: 'experienceleague.adobe.com',
    authorUrl: 'author-p122525-e1219150.adobeaemcloud.com',
    hlxPreview: 'main--exlm-prod--adobe-experience-league.hlx.page',
    hlxLive: 'main--exlm-prod--adobe-experience-league.hlx.live',
    appAssetsOrigin: 'https://51837-support.adobeio-static.net',
  },
  {
    env: 'STAGE',
    cdn: 'experienceleague-stage.adobe.com',
    authorUrl: 'author-p122525-e1219192.adobeaemcloud.com',
    hlxPreview: 'main--exlm-stage--adobe-experience-league.hlx.page',
    hlxLive: 'main--exlm-stage--adobe-experience-league.live',
    appAssetsOrigin: 'https://51837-support-stage.adobeio-static.net',
  },
  {
    env: 'DEV',
    cdn: 'experienceleague-dev.adobe.com',
    authorUrl: 'author-p122525-e1200861.adobeaemcloud.com',
    hlxPreview: 'main--exlm--adobe-experience-league.hlx.page',
    hlxLive: 'main--exlm--adobe-experience-league.hlx.live',
    appAssetsOrigin: 'https://51837-support-stage.adobeio-static.net',
  },
  {
    env: 'LOCAL',
    cdn: 'experienceleague-local.adobe.com',
    authorUrl: 'author-p122525-e1219192.adobeaemcloud.com',
    hlxPreview: 'main--exlm-stage--adobe-experience-league.hlx.page',
    hlxLive: 'main--exlm-stage--adobe-experience-league.live',
    appAssetsOrigin: 'https://experienceleague-local.adobe.com',
  },
];


export const currentHost = window.location.hostname;
export const defaultEnv = HOSTS.find((H) => H.env === 'STAGE');
export const currentEnv = HOSTS.find((H) => Object.values(H).includes(currentHost)) || {};
export const cdnHost = currentEnv?.cdn || defaultEnv.cdn;
export const cdnOrigin = `https://${cdnHost}`;







export const appAssetsOrigin = currentEnv.appAssetsOrigin || defaultEnv.appAssetsOrigin;

export const isProd = currentEnv?.env === 'PROD';
export const isLocal = window.location.href.includes('experienceleague-local.adobe.com');
export const ims = {
  client_id: 'ExperienceLeague',
  environment: isProd || isLocal ? 'prod' : 'stg1',
  debug: !isProd,
};

/**
 * COPIED FROM EXLM
 * Process current pathname and return details for use in language switching
 * Considers pathnames like /en/path/to/content and /content/exl/global/en/path/to/content.html for both EDS and AEM
 */
export function getPathDetails() {
  const { pathname } = window.location;
  const extParts = pathname.split('.');
  const ext = extParts.length > 1 ? extParts[extParts.length - 1] : '';
  const isContentPath = pathname.startsWith('/content');
  const parts = pathname.split('/');
  
  const safeLangGet = (index) => (parts.length > index ? parts[index] : 'en');
  
  // 4 is the index of the language in the path for AEM content paths like  /content/exl/global/en/path/to/content.html
  // 1 is the index of the language in the path for EDS paths like /en/path/to/content
  let lang = isContentPath ? safeLangGet(4) : safeLangGet(1);

  if (lang === 'zh-hans'){
    lang = 'zh-Hans'
  }
  if (lang === 'zh-hant'){
    lang = 'zh-Hant'
  }
  if (lang === 'pt-br'){
    lang = 'pt-BR'
  }
  
  // remove suffix from lang if any
  if (lang.indexOf('.') > -1) {
    lang = lang.substring(0, lang.indexOf('.'));
  }
  if (!lang) lang = 'en'; // default to en
  // substring before lang
  const prefix = pathname.substring(0, pathname.indexOf(`/${lang}`)) || '';
  const suffix = pathname.substring(pathname.indexOf(`/${lang}`) + lang.length + 1) || '';
  return {
    ext,
    prefix,
    suffix,
    lang,
    isContentPath,
  };
}
